import React from 'react';
import { ReadsTable } from '../ReadsTable';

export const Automated: React.FC = () => {
  return <ReadsTable methodFilter="Automated" />;
};
